import React from 'react';
import TaskQueue from './TaskQueue';

/** Consumer Xperience → Renewals: every renewal task, and nothing else. */
const RenewalsPage: React.FC = () => (
  <TaskQueue
    scope="renewal-only"
    title="Renewals"
    subtitle="Work through your renewal queue by urgency and SLA."
  />
);

export default RenewalsPage;
